/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Status_Fetching_VideoInputs */

const en_import_status_fetching_video = /** @type {(inputs: Import_Status_Fetching_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching video…`)
};

const de_import_status_fetching_video = /** @type {(inputs: Import_Status_Fetching_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video wird geladen…`)
};

/**
* | output |
* | --- |
* | "Fetching video…" |
*
* @param {Import_Status_Fetching_VideoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_status_fetching_video = /** @type {((inputs?: Import_Status_Fetching_VideoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Status_Fetching_VideoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_status_fetching_video(inputs)
	return en_import_status_fetching_video(inputs)
});